import React from 'react';
import { Box, Inscription } from '@common-fe/common-fe';

import WarnIconWithText from '../../ContributionEmployeesSettings/WarnIconWithText';

interface Props {
  testId?: string;
  errorMessage?: string;
  title?: string;
}

export const ViewedValue: React.FC<Props> = ({ errorMessage, title, testId }) => (
  <Box direction="row" align="center" data-testId={`ViewedValue_${testId}`}>
    <Inscription title={title} truncate {...errorMessage ? { color: 'danger' } : {}}>
      {title}
    </Inscription>
    {errorMessage ? (
      <Box margin={{ left: 'spacing4' }}>
        <WarnIconWithText message={errorMessage} iconSize="16px" />
      </Box>
    ) : null}
  </Box>
);
